<template>
   <div id="top" class="">
      <StepIndicator :store="store"></StepIndicator>

      <h2 class="text-2xl font-medium uppercase text-pilke-primary">{{storeState.activeStep.title}}</h2>

      <component class="mb-5" :is="storeState.activeStep.component" :store="store"></component>

      <div v-if="!store.validate(storeState.activeStep.component).valid" class="text-center">
         {{store.validate(storeState.activeStep.component).message}}
      </div>

      <div class="flex justify-between flex-row-reverse">
         <button v-if="store.validate(storeState.activeStep.component).valid && !store.isLastStep()" class="btn" @click="gotoNext()">Seuraava</button>
         <button v-if="!store.validate(storeState.activeStep.component).valid && !store.isLastStep()" disabled="disabled" class="btn">Seuraava</button>
         <button v-if="store.validate(storeState.activeStep.component).valid && store.isLastStep()" class="btn" type="button" @click="submitApplication">Lähetä tietoja lapsesta -lomake</button>
         <button v-if="!store.validate(storeState.activeStep.component).valid && store.isLastStep()" disabled="disabled" class="btn">Lähetä tietoja lapsesta -lomake</button>
         <button v-if="!store.isFirstStep()" class="btn" @click="gotoPrev()">Edellinen</button>
      </div>

   </div>
</template>

<script>
import Area from '@/views/Area'
import Child from '@/views/Child'
import Caretakers from '@/views/Caretakers'
import Need from '@/views/Need'
import Info from '@/views/Info'
import Summary from '@/views/Summary'
import StepIndicator from '@/components/StepIndicator'

export default {
   props: ['store'],

   components: {
      Area,
      Child,
      Caretakers,
      Need,
      Info,
      Summary,
      StepIndicator
   },

   data () {
      return {
         stepIsValid: true,
         storeState: this.store.state
      }
   },

   methods: {
      gotoNext () {
         this.store.nextStep()
         this.$scrollTo('#top')
      },

      gotoPrev () {
         this.store.prevStep()
         this.$scrollTo('#top')
      },

      submitApplication () {
         this.store.submitApplication()
      }
   }
}
</script>

<style scoped>
</style>
